module.exports = __webpack_public_path__ + "img/sjjzgl.9c53f8d4.jpg";